import makeClient from '../../urql/client'
import { getProvidersByScope } from '../../utils/providers'
import { PROVIDERS } from '../../utils/providers-listing'
import STORE_CUSTOMER_MUTATION from '~/components/landing-form/store-customer-mutation.gql'
import { getCookie } from '~/utils/cookies'

const getProviders = (scope) => getProvidersByScope(PROVIDERS, scope)

export const selectProvider = async (providerId, formId) => {
  const [client] = makeClient({ isServer: false, fetch, uscd: getCookie('uscd') })

  const mutationVariables = {
    customer: {
      provider: providerId,
      formStartedId: formId
    }
  }

  await client.mutation(STORE_CUSTOMER_MUTATION, mutationVariables).toPromise()

  return 'results'
}

export default { getProviders, selectProvider }
